// extracted by mini-css-extract-plugin
export var editButton = "_nw-0";